// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const Warning = React.forwardRef(function Warning(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></SvgIcon>;
});
export default Warning;
